<template>
  <div class="d-flex justify-content-between product-detail-properties-heading">
    <div class="product-detail-properties-label"><h4 class="gpdp-h4">{{ trans('Product details') }}</h4></div>
    <div class="product-detail-properties-info-icon"><a class="info-icon" href="#" @click="infoVisible = true">
      <font-awesome-icon :icon="infoIcon"/>
    </a></div>
  </div>
  <div class="gpdp-col product-detail-properties-line-info gpdp-lined-bottom"></div>
  <div class="product-detail-properties d-sm-flex flex-wrap">

    <div class="product-detail-properties-col pcol-1">
      <div class="prop-cell icon-prop buegellaenge">
        {{ getProp("buegellaenge") }}&nbsp;mm
      </div>
      <div class="prop-cell icon-prop weight">
        {{ getProp("weight") }}&nbsp;gr
      </div>
      <div class="prop-cell icon-prop brueckenweite">
        {{ getProp("brueckenweite") }}&nbsp;mm
      </div>
    </div>
    <div class="product-detail-properties-col pcol-2">
      <div class="prop-cell icon-prop scheibenlaenge">
        {{ getProp("scheibenlaenge") }}&nbsp;mm
      </div>
      <div class="prop-cell icon-prop scheibenhoehe">
        {{ getProp("scheibenhoehe") }} mm
      </div>
      <div class="prop-cell icon-prop">
      </div>
    </div>
    <div class="product-detail-properties-col pcol-3">
      <ul class="characteristics-list product-detail-characteristics">
        <li v-if='getProp("federscharnier")'>{{ trans('Federscharnier') }}</li>
        <li v-if='getProp("verglasbar")'>{{ trans('verglasbar') }}</li>
        <li v-if='getProp("farbverlauf")'>{{ trans('Farbverlauf') }}</li>
        <li>
          {{ trans('Material') }}:
          {{ trans(getProp("material")) }}
        </li>
      </ul>
    </div>
  </div>
  <BOffcanvas
    v-model='infoVisible'
    width="33%"
    style="min-width:340px"
    :class="'offcanvas-brand-' + glass.brand.toLowerCase() + ' offcanvas-site-' + brandSite"
    placement="end">
    <h4 class="pdp-info-title pb-5">{{ trans('Informationen zu den Produktdetails') }}</h4>
    <div class="container">
      <div class="d-flex">
        <div>
          <div class="icon-prop-w80 buegellaenge"></div>
        </div>
        <div class="pdp-info-desc">{{ trans('buegellaenge') }}</div>
      </div>
      <div class="d-flex">
        <div>
          <div class="icon-prop-w80 scheibenlaenge"></div>
        </div>
        <div class="pdp-info-desc">{{ trans('scheibenlaenge') }}</div>
      </div>
      <div class="d-flex">
        <div>
          <div class="icon-prop-w80 weight"></div>
        </div>
        <div class="pdp-info-desc">{{ trans('weight') }}</div>
      </div>
      <div class="d-flex">
        <div>
          <div class="icon-prop-w80 scheibenhoehe"></div>
        </div>
        <div class="pdp-info-desc">{{ trans('scheibenhoehe') }}</div>
      </div>
      <div class="d-flex">
        <div>
          <div class="icon-prop-w80 brueckenweite"></div>
        </div>
        <div class="pdp-info-desc">{{ trans('brueckenweite') }}</div>
      </div>
    </div>
  </BOffcanvas>
</template>

<script>
import {computed, ref} from 'vue'
import {BOffcanvas} from 'bootstrap-vue-next'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'


library.add(fas)
export default {
  name: "GlassItemProperties",
  itemView: "",
  props: {
    GlassItem: Object,
    translate: Function,
    icon: String,
    brandSite: String
  },
  setup(props) {
    const Properties = {
      material:"",
      federscharnier:false,
      verglasbar:false,
      rahmenart:"",
      scheibenform:"",
      aktuell:false,
      brueckenweite:"",
      buegellaenge:"",
      scheibenhoehe:"",
      scheibenlaenge:"",
      weight:0
    }
    const infoVisible = ref(false)
    const glass = computed(() => {
      return props.GlassItem
    })
    const trans = computed(() => {
      return props.translate
    })

    const infoIcon = computed(() => {
      console.log(props.icon)
      return props.icon
    })
    const getProperties = computed(() => {
      Object.keys(Properties).forEach(function(key) {
        Properties[key] = glass[key]
      })
      return Properties
    })
    return {
      glass,
      trans,
      infoVisible,
      getProperties,
      infoIcon

    }
  },
  methods: {
    getProp: function (property) {
      return this.glass && Object.hasOwn(this.glass,property) ? this.glass[property] : ""
    }
  },
  components: {
    BOffcanvas,
    FontAwesomeIcon
  }
};
</script>

